import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Replacement = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <title>{"Atom/icon/image/switch-flip/line@1x"}</title>
    <defs>
      <path
        d="M19.333 10.667c.342 0 .624.257.663.589l.004.077V12a4.666 4.666 0 01-4.506 4.664l-.16.003-7.058-.001 2.195 2.196c.24.24.26.618.056.88l-.056.063a.667.667 0 01-.88.055l-.062-.055-3.334-3.334-.012-.012a.67.67 0 01-.047-.056l.06.068a.67.67 0 01-.128-.177l-.006-.013A.662.662 0 016 16v-.013a.67.67 0 01.002-.044L6 16a.671.671 0 01.14-.409l.022-.026a.67.67 0 01.015-.017l.018-.02 3.334-3.333a.667.667 0 01.998.88l-.056.063-2.194 2.195h7.056a3.333 3.333 0 003.33-3.188l.004-.145v-.667c0-.368.298-.666.666-.666zm-1.395-2.948l.02.047A.667.667 0 0118 8v.013a.67.67 0 01-.002.035L18 8a.671.671 0 01-.14.409l-.022.026a.67.67 0 01-.015.017l-.018.02-3.334 3.333a.667.667 0 01-.998-.88l.056-.063 2.195-2.196H8.667a3.333 3.333 0 00-3.33 3.19L5.332 12v.667a.667.667 0 01-1.329.077L4 12.667V12a4.666 4.666 0 014.506-4.664l.16-.003h7.057l-2.194-2.195a.667.667 0 01-.056-.88l.056-.063a.667.667 0 01.88-.055l.062.055 3.334 3.334.012.012a.67.67 0 01.047.056l-.06-.068a.67.67 0 01.128.177l.006.013z"
        id="prefix__a-replacement"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b-replacement" fill="#fff">
        <use xlinkHref="#prefix__a-replacement" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#prefix__a-replacement" />
      <g
        mask="url(#prefix__b-replacement)"
        fill={props.color || theme.palette.grey600}
      >
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
